<template>
    <section class="deals">
      <div class="container">
        <h2 class="section-title">Flash Deals</h2>
        <div class="deals-timer">
          <div class="timer-item">
            <span class="time">{{ hours }}</span>
            <span class="label">Hours</span>
          </div>
          <div class="timer-item">
            <span class="time">{{ minutes }}</span>
            <span class="label">Minutes</span>
          </div>
          <div class="timer-item">
            <span class="time">{{ seconds }}</span>
            <span class="label">Seconds</span>
          </div>
        </div>
        <div class="deals-grid">
          <div class="deal-card" v-for="deal in deals" :key="deal.id">
            <div class="deal-image">
              <img :src="deal.image" :alt="deal.name">
            </div>
            <div class="deal-info">
              <h3>{{ deal.name }}</h3>
              <div class="deal-price">
                <span class="current-price">${{ deal.price }}</span>
                <span class="old-price">${{ deal.oldPrice }}</span>
                <span class="discount">-{{ deal.discount }}%</span>
              </div>
              <div class="deal-progress">
                <div class="progress-bar">
                  <div class="progress" :style="{ width: deal.progress + '%' }"></div>
                </div>
                <div class="progress-text">
                  <span>Sold: {{ deal.sold }}/{{ deal.total }}</span>
                </div>
              </div>
              <button class="btn-add-cart">Add to Cart</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'DealsSection',
    data() {
      return {
        hours: 23,
        minutes: 59,
        seconds: 59,
        timer: null,
        deals: [
          {
            id: 1,
            name: '55" Smart TV 4K',
            image: '../../assets/images/placeholder.svg', //?height=200&width=200
            price: 499,
            oldPrice: 799,
            discount: 38,
            sold: 75,
            total: 100,
            progress: 75
          },
          {
            id: 2,
            name: 'Premium Coffee Maker',
            image: '../../assets/images/placeholder.svg', //?height=200&width=200
            price: 89,
            oldPrice: 149,
            discount: 40,
            sold: 60,
            total: 100,
            progress: 60
          }
        ]
      }
    },
    mounted() {
      this.startTimer()
    },
    // beforeDestroy() {
    //   clearInterval(this.timer)
    // },
    methods: {
      startTimer() {
        this.timer = setInterval(() => {
          if (this.seconds > 0) {
            this.seconds--
          } else {
            this.seconds = 59
            if (this.minutes > 0) {
              this.minutes--
            } else {
              this.minutes = 59
              if (this.hours > 0) {
                this.hours--
              } else {
                // Timer ended
                clearInterval(this.timer)
              }
            }
          }
        }, 1000)
      }
    }
  }
  </script>
  
  <style scoped>
  .deals {
    padding: 60px 0;
    background-color: var(--gray-light);
  }
  
  .deals-timer {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-bottom: 30px;
  }
  
  .timer-item {
    background-color: var(--primary-color);
    color: var(--white);
    width: 70px;
    height: 70px;
    border-radius: var(--border-radius);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  
  .timer-item .time {
    font-size: 24px;
    font-weight: 700;
  }
  
  .timer-item .label {
    font-size: 12px;
  }
  
  .deals-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }
  
  .deal-card {
    display: flex;
    background-color: var(--white);
    border-radius: var(--border-radius);
    overflow: hidden;
    box-shadow: var(--box-shadow);
  }
  
  .deal-image {
    flex: 0 0 40%;
    padding: 20px;
    background-color: var(--gray-light);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .deal-info {
    flex: 1;
    padding: 20px;
  }
  
  .deal-info h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  
  .deal-price {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
  }
  
  .current-price {
    font-size: 18px;
    font-weight: 700;
    color: var(--primary-color);
  }
  
  .old-price {
    font-size: 14px;
    color: var(--text-light);
    text-decoration: line-through;
  }
  
  .discount {
    background-color: var(--error);
    color: var(--white);
    padding: 2px 5px;
    border-radius: var(--border-radius);
    font-size: 12px;
    font-weight: 600;
  }
  
  .deal-progress {
    margin-bottom: 15px;
  }
  
  .progress-bar {
    height: 10px;
    background-color: var(--gray-light);
    border-radius: 5px;
    overflow: hidden;
    margin-bottom: 5px;
  }
  
  .progress {
    height: 100%;
    background-color: var(--primary-color);
  }
  
  .progress-text {
    font-size: 12px;
    color: var(--text-light);
  }
  .btn-add-cart {
    width: 100%;
    padding: 10px;
    background-color: var(--primary-color);
    color: var(--white);
    border: none;
    border-radius: var(--border-radius);
    font-weight: 600;
    transition: var(--transition);
  }
  
  .btn-add-cart:hover {
    background-color: var(--primary-dark);
  }
  
  @media (max-width: 992px) {
    .deals-grid {
      grid-template-columns: 1fr;
    }
  }
  
  @media (max-width: 768px) {
    .deal-card {
      flex-direction: column;
    }
    
    .deal-image {
      flex: 0 0 auto;
    }
  }
  </style>